var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(_vm.showTips)?_c('span',[_vm._v("当前登录态异常，请重新登录"+_vm._s(_vm.platformName)+"，然后再访问千川。即将前往"+_vm._s(_vm.platformName)+"...")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }